import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Loader2, Wifi } from 'lucide-react'

interface TestConnectionDialogProps {
  isOpen: boolean
  dataSourceName: string
}

const TestConnectionDialog: React.FC<TestConnectionDialogProps> = ({
  isOpen,
  dataSourceName
}) => {
  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Wifi className="h-5 w-5" />
            Testing Connection
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center py-8">
          <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
          <h3 className="text-lg font-semibold mb-2">Testing Connection</h3>
          <p className="text-sm text-muted-foreground text-center">
            Testing connection to <strong>{dataSourceName}</strong>...
            <br />
            This may take a few moments.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default TestConnectionDialog 